import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { getLiquidStakingTokenContract } from 'modules/api/contracts/getLiquidStakingTokenContract';
import { getPublicClient } from 'modules/api/getPublicClient';
import { convertFromWei } from 'modules/api/utils';

export async function getStakeTokenBalance(
  accountAddress: Address,
  poolAddress?: Address,
): Promise<BigNumber> {
  const contract = getLiquidStakingTokenContract(
    getPublicClient(),
    poolAddress,
  );

  const balanceWei: bigint = await contract.read.balanceOf([accountAddress]);

  return convertFromWei(balanceWei);
}
